// Module
var code = "<div id=\"auth0-error\"> <start-logo></start-logo> <h3 class=\"label-text\"> {{vm.errorMsg}} </h3> </div>";
// Exports
module.exports = code;